import { FieldLabel } from "../AdminCommon";
import { ProductionSubcategoryManager } from "./ProductionSubcategoryManager";
import { CONTROLE_MODE_OPTIONS } from "./ehpadRules";
import {
    btnOutlineDangerStyle,
    btnOutlineStyle,
    btnPurpleOutlineStyle,
    fieldStyle,
    inputStyle,
} from "../styles/adminDashboardStyles";

// Champs de la fiche EHPAD : code, nom, coordonnées, tournée, mode de contrôle, couleur et sous-catégories.
export function EhpadIdentityFields({ ehpad, tournees, form, setForm }) {
    return (
        <>
            <div style={{ ...fieldStyle, width: "110px" }}>
                <FieldLabel required>Code</FieldLabel>
                <input id={`admin-edit-ehpad-${ehpad.id}-code`} style={inputStyle} value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value }))} required />
            </div>
            <div style={{ ...fieldStyle, flex: "1 1 180px" }}>
                <FieldLabel required>Nom</FieldLabel>
                <input id={`admin-edit-ehpad-${ehpad.id}-name`} style={inputStyle} value={form.nom} onChange={e => setForm(f => ({ ...f, nom: e.target.value }))} required />
            </div>
            <div style={{ ...fieldStyle, flex: "1 1 180px" }}>
                <FieldLabel>Adresse</FieldLabel>
                <input id={`admin-edit-ehpad-${ehpad.id}-address`} style={inputStyle} value={form.address} onChange={e => setForm(f => ({ ...f, address: e.target.value }))} />
            </div>
            <div style={{ ...fieldStyle, width: "130px" }}>
                <FieldLabel>Téléphone</FieldLabel>
                <input id={`admin-edit-ehpad-${ehpad.id}-phone`} style={inputStyle} value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
            </div>
            <div style={{ ...fieldStyle, width: "160px" }}>
                <FieldLabel>Tournée</FieldLabel>
                <select id={`admin-edit-ehpad-${ehpad.id}-tournee`} style={inputStyle} value={form.tourneeId} onChange={e => setForm(f => ({ ...f, tourneeId: e.target.value }))}>
                    <option value="">— Aucune —</option>
                    {tournees.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                </select>
            </div>
            <div style={{ ...fieldStyle, width: "190px" }}>
                <FieldLabel>Mode contrôle</FieldLabel>
                <select id={`admin-edit-ehpad-${ehpad.id}-controle-mode`} style={inputStyle} value={form.controleMode} onChange={e => setForm(f => ({ ...f, controleMode: e.target.value }))}>
                    {CONTROLE_MODE_OPTIONS.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                </select>
            </div>
            <div style={{ ...fieldStyle, width: "90px" }}>
                <FieldLabel>Couleur</FieldLabel>
                <input
                    id={`admin-edit-ehpad-${ehpad.id}-color`}
                    aria-label={`Couleur de ${ehpad.nom}`}
                    type="color"
                    value={form.color}
                    onChange={e => setForm(f => ({ ...f, color: e.target.value.toUpperCase() }))}
                    style={{ ...inputStyle, height: "38px", padding: "3px", cursor: "pointer" }}
                />
            </div>
            <div style={{ ...fieldStyle, flex: "1 1 100%" }}>
                <FieldLabel>Sous-catégorie (planning, production, etc.) (facultatif)</FieldLabel>
                <ProductionSubcategoryManager
                    inputId={`admin-edit-ehpad-${ehpad.id}-production-subcategory`}
                    values={form.productionSubcategories}
                    draft={form.productionSubcategoryDraft}
                    onDraftChange={value => setForm(f => ({ ...f, productionSubcategoryDraft: value }))}
                    onValuesChange={values => setForm(f => ({ ...f, productionSubcategories: values }))}
                />
            </div>
        </>
    );
}

function PendingInvitationControls({ pendingInvitation, saving, actions }) {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
            <button
                type="button"
                onClick={actions.handleResend}
                disabled={actions.resending || saving || actions.cancellingInvitation}
                style={pendingInvitation.blocked && !pendingInvitation.expired ? btnOutlineDangerStyle : btnPurpleOutlineStyle}
            >
                {actions.resending ? "Envoi..." : (pendingInvitation.blocked || pendingInvitation.expired) ? "Renvoyer une invitation" : "Régénérer le code"}
            </button>
            <button
                type="button"
                onClick={() => actions.setConfirmCancelInvitation(true)}
                disabled={actions.resending || saving || actions.cancellingInvitation}
                style={btnOutlineStyle}
            >
                Annuler le raccordement
            </button>
            <span style={{ fontSize: "12px", color: "#6b7280" }}>
                Envoie un nouveau lien et un nouveau code à {pendingInvitation.email} ; l'ancien ne fonctionne plus.
            </span>
        </div>
    );
}

function ConnectedControls({ saving, actions }) {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
            <button
                type="button"
                onClick={() => actions.setConfirmCancelInvitation(true)}
                disabled={saving || actions.cancellingInvitation}
                style={btnOutlineStyle}
            >
                Annuler le raccordement
            </button>
            <span style={{ fontSize: "12px", color: "#6b7280" }}>
                Désactive le lien entre cet EHPAD et la pharmacie.
            </span>
        </div>
    );
}

function ManagerLinkControls({ saving, actions }) {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
            <button
                type="button"
                onClick={actions.handleLink}
                disabled={saving || actions.linking}
                style={btnPurpleOutlineStyle}
            >
                {actions.linking ? "Envoi..." : "Créer le raccordement"}
            </button>
            <span style={{ fontSize: "12px", color: "#6b7280" }}>
                Cet EHPAD a déjà un responsable sur le portail : il reçoit un lien et un code pour valider le raccordement, sans création de compte.
            </span>
        </div>
    );
}

function ReactivateControls({ deactivatedEmail, saving, actions }) {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", flexWrap: "wrap" }}>
            <button
                type="button"
                onClick={actions.handleReactivate}
                disabled={saving || actions.reactivating}
                style={btnPurpleOutlineStyle}
            >
                {actions.reactivating ? "Envoi..." : "Réactiver le raccordement"}
            </button>
            <span style={{ fontSize: "12px", color: "#6b7280" }}>
                Envoie une invitation (lien et code) à l'email saisi ci-dessus, ou à {deactivatedEmail} si le champ est vide.
            </span>
        </div>
    );
}

// Boutons de raccordement selon la situation : invitation en cours, EHPAD raccordé, responsable créé par le portail
// ou raccordement désactivé.
export function EhpadConnectionControls({ connection, connected, pendingInvitation, deactivatedEmail, saving, actions }) {
    const props = { pendingInvitation, deactivatedEmail, saving, actions };
    return (
        <>
            {pendingInvitation && <PendingInvitationControls {...props} />}
            {connected && <ConnectedControls {...props} />}
            {connection === "manager" && !pendingInvitation && <ManagerLinkControls {...props} />}
            {connection === "deactivated" && !pendingInvitation && deactivatedEmail && <ReactivateControls {...props} />}
        </>
    );
}
